import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { notificationTemplateDetailLoad } from 'store/models/notificationTemplate';
import { DetailLoadComponent } from 'components/common';

const NotificationTemplateValue = (props) => {
  return (
    <DetailLoadComponent
      apiLoad={notificationTemplateDetailLoad(props.site.activeDomain)}
      {...props}
      getDetailUrl={(id, item) => props.model.urls.detail(id)}
      render={({ id, item, linkPath }) => {
        const value = (item && item.email_subject_tpl) || id;

        return (
          <Fragment>{props.asLink && linkPath ? <Link to={linkPath}>{value}</Link> : <span>{value}</span>}</Fragment>
        );
      }}
    />
  );
};

const mapState = (state) => ({
  router: state.router,
  authToken: state.auth.token,
  model: state.notificationTemplate,
  site: state.site,
});

export default connect(mapState)(NotificationTemplateValue);
